import React,{useEffect} from 'react'
import axios from 'axios';
import { Spin, Table } from "antd";


import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Spinner,
  Select
} from '@chakra-ui/react';

function Status() {

  const [tableColumns, setTableColumns] = React.useState([])
  const [tableData, setTableData] = React.useState([])
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const handleFetchStatus = async () => {
    if(tableData.length === 0){
      try{
        setLoading(true);
        const response = await axios.get('https://rightofway.erc.uic.edu/wp-json/status_route/v1/status_route');
        //console.log('submission data', response.data);
        if(response.data.length > 0){
          setTableData(response.data);
        }
        setLoading(false);
      }
      catch(error){
        setLoading(false);
        setError(true);
        console.log(error);
      }
    }
  }

  const columns = [
    {
      title: 'Organization Name',
      dataIndex: 'organization_name',
      key: 'organization_name',
    },
    {
      title: 'Submission Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        if(text === 'submitted'){
          return <Text color='green.500'>{text}</Text>
        }
        else{
          return <Text color='red.500'>{text}</Text>
        }
      }
    }
  ];

  useEffect(() => {
    if(tableData.length === 0){
      handleFetchStatus();
    }
  }
  ,[])


  return (
    <>
      <div className='container-fluid'>
          <div className='row'>
              <Text
                fontSize="2xl"
                fontWeight="bold"
                letterSpacing="wide"
                color="gray.700"
                textAlign='center'
                mt={10}
              >
                  Monarch CCAA Annual Report Submission Status
              </Text>
          </div>
          <div className='row mt-4'>
            <Table
              columns={columns}
              loading={loading}
              error={error}
              dataSource={tableData.map((row) => ({
                ...row,
                key: row.organization_name,
              }))}
              defaultPageSize={20}
              pageSizeOptions={[10, 20, 30]}
              scroll={{
                x: "max-content",
                y: "max-content"
              }}
              rowKey="organization_name"

            />
          </div>
      </div>
    </>
  )
}

export default Status